import React from 'react';

import { language, baseAppId } from 'settings';

import { ContactCard } from 'C4';

const ContactView = () => {
  let contacts = [];

  // only works for 'en' langue right now
  language.forEach((l) => {
    if (l.id === baseAppId) contacts = l.contacts;
  });

  return (
    <div className="contentContainer contact">
      {/* <BackButton /> */}
      <div className="contactView__Header" />
      <div className="contactView__CardContainer">
        {contacts.map((contact) => {
          return (
            <ContactCard
              key={contact.name}
              role={contact.title}
              name={contact.name}
              email={contact.email}
              phone={contact.phone}
              options={contact.options}
              img={contact.avatar}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ContactView;
